import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import deletedAttendeeService from '../services/deletedAttendeeService';

const deletedAttendeesCollectionName = "deleted_attendees";

export const useDeletedAttendeeData = () => {
  return useQuery({
    queryKey: [deletedAttendeesCollectionName],
    queryFn: () => deletedAttendeeService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useRestoreDeletedAttendee = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: (attendeeId) => deletedAttendeeService.restore(attendeeId),
      onSuccess: () => {
        // Invalidate both collections after successful restore
        queryClient.invalidateQueries({ queryKey: [deletedAttendeesCollectionName] });
        queryClient.invalidateQueries({ queryKey: ['attendees'] });
      },
    });
};
export const useDeleteFromDeletedAttendee = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (attendeeId) => deletedAttendeeService.delete(attendeeId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [deletedAttendeesCollectionName] });  
    }   
  })
  
}